import { render } from "./NavbarPartial.vue?vue&type=template&id=635ab04b"
import script from "./NavbarPartial.vue?vue&type=script&lang=js"
export * from "./NavbarPartial.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__